module.exports = __webpack_public_path__ + "static/Banner-28-886589c8b315c936d93da873173d2fc7.png";